import { Apollo } from 'apollo-angular'
import { ApolloQueryResult } from '@apollo/client/core'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { cloneDeep } from 'lodash'
import { camel, safeGet, StringObjectLiteral } from '../../util/util'
import { studiesDetails_study_by_pk } from '../studies-details/types/studiesDetails'
import editMutation from './studies-edit.gql'
import relatedEntityQuery from './study_get_related_entities.gql'
import { edit_study_by_pk } from './types/edit_study_by_pk'
import { study_get_related_entities } from './types/study_get_related_entities'

@Component({
  selector: 'app-studies-edit',
  templateUrl: './studies-edit.component.html',
  styleUrls: ['./studies-edit.component.scss'],
})
export class StudiesEditComponent implements OnInit {
  @Input() study: studiesDetails_study_by_pk

  private _backup_study: studiesDetails_study_by_pk

  @Output() saveEvent = new EventEmitter()

  safeGet = safeGet

  objectKeys = Object.keys

  relatedEntityOptionsQueryResult: ApolloQueryResult<study_get_related_entities>

  constructor(private apollo: Apollo) {}

  fetchRelatedEntityOptions() {
    this.apollo
      .query<study_get_related_entities>({ query: relatedEntityQuery })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            throw result.errors[0]
          }
          this.relatedEntityOptionsQueryResult = result
        },
      })
  }

  get relatedEntityOptions(): study_get_related_entities {
    return this.relatedEntityOptionsQueryResult.data
  }

  ngOnInit() {
    this._backup_study = cloneDeep(this.study)
    this.fetchRelatedEntityOptions()
  }

  save() {
    this.apollo
      .mutate<edit_study_by_pk>({
        mutation: editMutation,
        variables: {
          id: this.study.id,
          _set: this.stripInput(this.study),
        },
      })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            throw result.errors[0]
          }
          this.saveEvent.emit('edit')
        },
      })
  }

  back() {
    this.study = cloneDeep(this._backup_study)
    this.saveEvent.emit('back')
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stripInput = (obj: StringObjectLiteral<any>) =>
    Object.keys(obj).reduce((newObj, key) => {
      if (
        key !== 'id' &&
        key !== 'dateCreated' &&
        key !== 'dateUpdated' &&
        key !== '__typename'
      ) {
        if (
          typeof obj[key] === 'string' ||
          typeof obj[key] === 'number' ||
          (obj[key] === null && key.slice(-2) === 'Id')
        ) {
          newObj[camel(key)] = obj[key]
        }
      }
      return newObj
    }, {})
}
